package it.neckar.lizergy.model.configuration.moduleLayout.roof

import it.neckar.lizergy.model.configuration.components.ConfigurationItem
import it.neckar.lizergy.model.configuration.components.ConfigurationItem.ConfigurationItemId
import it.neckar.open.collections.fastForEach
import it.neckar.uuid.HasValueClassUuid
import it.neckar.uuid.NativeUuid
import it.neckar.uuid.ValueClassUuid
import it.neckar.uuid.randomUuid4
import it.neckar.uuid.withAdded
import it.neckar.uuid.withRemoved
import it.neckar.uuid.withReplaced
import kotlinx.serialization.Serializable
import kotlin.uuid.Uuid

@Serializable
data class ConfigurationItemsConfiguration(
  override val id: ConfigurationItemsConfigurationId,
  val configurationItems: List<ConfigurationItem>,
) : HasValueClassUuid {

  operator fun get(itemId: Uuid): ConfigurationItem {
    return configurationItems.firstOrNull { quoteItem ->
      quoteItem.id.uuid == itemId
    } ?: throw NoSuchElementException("No ConfigurationItem with id <$itemId> found. Available items: ${configurationItems.map { it.id }}")
  }

  operator fun get(itemId: ConfigurationItemId): ConfigurationItem {
    return get(itemId.uuid)
  }

  fun fastForEach(function: (ConfigurationItem) -> Unit) {
    configurationItems.fastForEach { function(it) }
  }

  fun withAdded(additionalItem: ConfigurationItem): ConfigurationItemsConfiguration {
    val updatedRoofs = configurationItems.withAdded(additionalItem)
    return copy(configurationItems = updatedRoofs)
  }

  fun withReplaced(updatedItem: ConfigurationItem): ConfigurationItemsConfiguration {
    return copy(configurationItems = configurationItems.withReplaced(updatedItem))
  }

  fun withRemoved(itemToRemove: ConfigurationItem): ConfigurationItemsConfiguration {
    return copy(configurationItems = configurationItems.withRemoved(itemToRemove))
  }

  fun duplicate(mapOfOldToNewUuids: MutableMap<Uuid, Uuid>): ConfigurationItemsConfiguration {
    val newId = ConfigurationItemsConfigurationId.random()
    mapOfOldToNewUuids[id.uuid] = newId.uuid
    return copy(
      id = newId,
      configurationItems = configurationItems.map { it.duplicate(mapOfOldToNewUuids) },
    )
  }


  @Serializable
  data class ConfigurationItemsConfigurationId(override val uuid: NativeUuid) : ValueClassUuid {

    override fun toString(): String {
      return uuid.toString()
    }

    fun format(): String {
      return uuid.toString()
    }

    companion object {
      fun random(): ConfigurationItemsConfigurationId {
        return ConfigurationItemsConfigurationId(randomUuid4())
      }
    }
  }


  companion object {
    fun getEmpty(id: ConfigurationItemsConfigurationId = ConfigurationItemsConfigurationId.random()): ConfigurationItemsConfiguration {
      return ConfigurationItemsConfiguration(id = id, configurationItems = emptyList())
    }
  }
}
